import { render, staticRenderFns } from "./Dashboard2.vue?vue&type=template&id=69fa23ea"
import script from "./Dashboard2.vue?vue&type=script&lang=js"
export * from "./Dashboard2.vue?vue&type=script&lang=js"
import style0 from "./Dashboard2.vue?vue&type=style&index=0&id=69fa23ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports